module.exports = __webpack_public_path__ + "static/sigma-3-76f95011bc87bce9092935f5f5f9049b.gif";